var map = {
	"./000_insti.jpg": 137,
	"./000_insti_mobile.jpg": 138,
	"./00_gauchahoje.jpg": 139,
	"./00_gauchahoje_mobile.jpg": 140,
	"./01_central.jpg": 141,
	"./01_central_mobile.jpg": 142,
	"./02_supermanha.jpg": 143,
	"./02_supermanha_mobile.jpg": 144,
	"./03_variedades.jpg": 145,
	"./03_variedades_mobile.jpg": 146,
	"./05_gazetaesporte.jpg": 147,
	"./05_gazetaesporte_mobile.jpg": 148,
	"./06_salaredacao.jpg": 149,
	"./06_salaredacao_mobile.jpg": 150,
	"./07_topbandas.jpg": 151,
	"./07_topbandas_mobile.jpg": 152,
	"./08_ladoalado.jpg": 153,
	"./08_ladoalado_mobile.jpg": 154,
	"./09_vozdobrasil.jpg": 155,
	"./09_vozdobrasil_mobile.jpg": 156,
	"./10_showesportes.jpg": 157,
	"./10_showesportes_mobile.jpg": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;